const getGateway = () => {
  switch (process.env.CONFIG_ENV) {
    case 'test':
      return '/ui/adman-gateway-test/'
    case 'beta':
      return '//iadluck.netease.com/test/adman-gateway-beta/'
    case 'test-ndp':
      return '//iadluck.netease.com/ui/adman-gateway-test/'
    case 'performance':
      return '//iadluck.netease.com/test/adman-gateway-performance/'
    case 'alpha':
      return '//iadluck.netease.com/ui/adman-gateway-alpha/'
    default:
      return '/api/'
  }
}

const gateway = getGateway()
export default gateway
